/* eslint-disable1 */
// FWSD-5216 - video DOMException: play() failed because the user didn't interact with the document first
// To make the video autoplay on html 5 elements work after the chrome 66 update you just need to add the muted property to the video element.
// https://developer.chrome.com/blog/autoplay/ - Autoplay policy in Chrome
// https://developer.mozilla.org/en-US/docs/Web/Media/Autoplay_guide - Autoplay and autoplay blocking
import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from "react-router-dom";
import { connect } from 'react-redux'
import { toastr } from 'react-redux-toastr'
import { useTranslation } from 'react-i18next'

import PermalinkVideo from './PermalinkVideo'
import PermalinkSnapshots from './PermalinkSnapshots'

import 'bootstrap-slider/dist/css/bootstrap-slider.css'
import '../webplayer/webplayer.sass'
import './AdvancedPlayerPermalink.sass'
import {
	getEventsPermalink,
	getEventsPermalinkHash
} from "../../../action/AlertActions";

const AdvancedPlayerPermalink = (props) => {
	const params = useParams();
	const { toggleLoader } = props;
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'permalinksPage.advancedPlayerOpenClip' });
	const location = useLocation();
	const [state, setState] = useState({
		videoUrls: [],
		setNvrUrl: '',
		snapshotUrls: [],
		metadatasUrl: '',
		driver: '',
	});

	useEffect(() => {
		toggleLoader(true)
		let funcName = ''
		if (location.pathname.includes('event/permalink')) {
			funcName = getEventsPermalinkHash({ event_hash: params.eventHash })
		}
		else {
			funcName = getEventsPermalink({ permalink_id: params.permalinkID })
		}

		funcName
			.then((res, err) => {
				const { response } = res.data

				if (response.error) {
					toastr.error(i18n.t('errorMessage.errDescription'))
				}
				else {
					const { video_urls, nvr_url, snapshots_urls, driver, metadata_url } = response
					setState((prevState) => ({
						videoUrls: video_urls || [],
						setNvrUrl: nvr_url || '',
						snapshotUrls: snapshots_urls || [],
						metadatasUrl: metadata_url || '',
						driver: driver || '',
					}))
				}

				toggleLoader(false)
			})
			.catch((error) => {
				toggleLoader(false)
				console.log('!getPermalinkEventVideo error: ', error.response, error)
				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			})
	}, [])

	if (state.videoUrls.length) {
		return <PermalinkVideo
			params={params}
			videoUrls={state.videoUrls}
			nvrUrl={state.nvrUrl}
			metadatasUrl={state.metadatasUrl}
			snapshotUrls={state.snapshotUrls}
			driver={state.driver}
		/>
	}
	if (state.snapshotUrls.length) {
		return <PermalinkSnapshots
			snapshotUrls={state.snapshotUrls}
		/>
	}

	return (
		<div>
			{t('eventNotExist')}
			{props.loader}
		</div>
	)
}

const mapStateToProps = ({ loader }) => ({
	loader: loader.loader,
})

const mapDispatchToProps = (dispatch) => {
	return {
		toggleLoader: (show) => {
			dispatch({ type: 'TOGGLE_LOADER', payload: show });
		},
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedPlayerPermalink);
